export const clientId = "smx-it-asset";
export const prefix = "asset.it.";
